import React, { memo } from 'react'
import { Text , ErrorIcon} from '@pancakeswap/uikit'
import { ErrorNetWork } from './style'

function App() {
  return (
    <ErrorNetWork>
      <ErrorIcon color='red' width='30px' />
      <Text>网络连接失败</Text>
    </ErrorNetWork>
  )
}

export default memo(App)